<template>
    <div id="myModal" class="modal">
      <!-- Modal content -->
      <div class="modal-content">
        <p>Убедитесь что программа NCALayer запущена и повторите попытку.</p>
        <button class="close">Хорошо</button>
      </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.modal {
  display: none; 
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 10px;
  width: 30%;
  text-align: center;
}

/* The Close Button */
.close {
    padding: .5rem 1rem;
    margin: 1rem 0 0;
    text-align: center;
}

.close:hover,
.close:focus {
    cursor: pointer;
}
</style>